import { validationMessages, staticConstants, NUMERIC_VALUE } from './constants';

export const profileImageValidation = (register, name) => {
  register(
    { name, type: 'custom', message: validationMessages.PROFILE_IMAGE },
    {
      validate: {
        mimeType: (value) => value && staticConstants.PROFILE_IMAGE_MIME.indexOf(value.type) >= 0,
        maxSize: (value) => value && value.size <= NUMERIC_VALUE.MAX_PROFILE_IMAGE_SIZE,
      },
    },
  );
};

export const coverImageValidation = (register, name) => {
  register(
    { name, type: 'custom', message: validationMessages.COVER_IMAGE },
    {
      validate: {
        mimeType: (value) => value && staticConstants.PROFILE_IMAGE_MIME.indexOf(value.type) >= 0,
        maxSize: (value) => value && value.size <= NUMERIC_VALUE.MAX_PROFILE_IMAGE_SIZE,
      },
    },
  );
};

export const startDateValidation = (register, name, value) => {
  register(
    { name, type: 'custom', message: validationMessages.REQUIRED },
    {
      validate: () => (value ? typeof value === 'object' : !!value),
    },
    {
      required: (value ? typeof value === 'object' : !!value),
    },
  );
};

export const endDateValidation = (register, name, dateValue) => {
  register(
    { name, type: 'custom', message: validationMessages.REQUIRED },
    {
      validate: () => (dateValue ? typeof dateValue === 'object' : !!dateValue),
    },
    {
      required: (dateValue ? typeof dateValue === 'object' : !!dateValue),
    },
  );
};

export const segmentInputDescValidation = (register, name, value) => {
  register(
    { name, type: 'custom', message: validationMessages.REQUIRED },
    {
      required: !value || !value.length,
    },
  );
};

export const selectValidation = (register, name) => {
  register(
    { name, type: 'custom', message: validationMessages.REQUIRED },
    {
      validate: (value) => (Array.isArray(value) ? value.length > 0 : !!value),
    },
  );
};

export const contactNumberValidation = (register, name) => {
  register({ name }, { required: true, maxLength: NUMERIC_VALUE.TWO_HUNDRED, minLength: NUMERIC_VALUE.FOUR });
};

export const shareTypeValidation = (register, name, value, isOptional) => {
  const shareTypeObj = value && Object.assign({}, ...value);
  const isChecked = Object.values(shareTypeObj).some((val) => val === true);
  register(
    { name, type: 'custom', message: validationMessages.REQUIRED },
    {
      required: isOptional ? !isOptional : !isChecked,
    },
  );
};
